<template>
  <modal
    class="panel-activity p-0"
    :show="showModal"
    :show-content="showContent"
    :page-title="modalTitle"
    :close-btn="closeBtn"
    :position="position"
    :size="size"
    @close="closeModal"
  >
    <template #content>
      <div class="ct-aside-control-item">
        <infinity-scroll
          ref="scroll"
          class-wrapper-list="ct-aside-control-body"
          :load-more-records="txtLoadMoreRecords"
          :no-records="txtNoRecords"
          :url="url"
          @onLoadData="onLoadData"
        >
          <template #header>
            <div class="ct-aside-control-header">
              <div class="title d-flex justify-content-between align-items-center w-100">
                {{ modalTitle }}
                <span v-if="reloadBtn" class="cursor-pointer">
                  <i class="fas fa-repeat repeat-icon" @click.prevent="reloadData"></i>
                 </span>
              </div>
            </div>
          </template>
          <template #list="{item}">
            <ItemMap
              :item="item"
              :txt-link-map="`${idPanel}.item.link_map`"
              :label-code="`${idPanel}.item.code`"
              :label-address="`${idPanel}.item.address`"
              :label-created-at="`${idPanel}.item.created_at`"
              :label-days-overdue="`${idPanel}.item.days_overdue`"
              @selectItem="onSelectItem"
            />
          </template>
        </infinity-scroll>
      </div>
    </template>
  </modal>
</template>

<script type="text/javascript">
    import PanelMap from '@/app/shared/mixins/parts/PanelMap';

    export default
    {
        name: 'PanelMapOverdue',
        components: {
            InfinityScroll: () => import(/* webpackChunkName: "infinity-scroll" */ '@/components/common/InfinityScroll'),
            ItemMap: () => import(/* webpackChunkName: "card-item-map" */ './components/CardItemMap'),
        },
        mixins: [PanelMap],
        props: {
          position: {
              type: String,
              default: 'right',
          },
          size: {
              type: String,
              default: '',
          },
          loadMoreRecords: {
              type: String,
              default: '',
          },
          eventsReload: {
              type: Array,
              default: () => ['map.reload', 'map.reload-overdue']
          },
          hasConfirmation: {
              type: Boolean,
              default: true
          },
          propIdPanel: {
              type: String,
              default: 'overdue'
          },
        },
        data() {
            return {
                idPanel: this.propIdPanel,
                loaded: false,
                showContent: true,
                activitys: [],
            }
        },
        computed: {
            txtLoadMoreRecords() {
                return this.$t(this.loadMoreRecords || this.ctrlPanel.txtLoadMoreRecords);
            },
        },
        methods: {
            onLoadData: function(data) {
                this.loaded = true;
                this.$store.dispatch(`${this.moduleCode}/setPanel`, {
                    id: this.idPanel,
                    loaded: true,
                    summary: [{
                        name: this.modalTitle,
                        num: data.total,
                        titleTemplate: this.titleTemplate
                    }],
                    reload: false,
                });
            },
            onSelectItem: function(item) {
                this.$emit('selectFeature', item);
            },
            reloadData() {
                if (!this.hasConfirmation) {
                    this.$refs.scroll.reloadData();
                    return;
                }

                this.$root.$emit('openConfirmation', {
                    id: null,
                    data: null,
                    text: this.$t(`${this.idPanel}.msg.confirm.reload`),
                    callback: () => {
                        this.$refs.scroll.reloadData();
                    }
                });
            },
        },
    }
</script>